import React, { useState,useRef } from 'react';
import { Button, TextField, Checkbox, FormControlLabel, FormGroup, Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import SaveIcon from '@mui/icons-material/Save';
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';
import axios from 'axios';
import { toast } from 'react-toastify';

const CreateBrandForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    image: null,
    publish: false
  });
 const fileInputRef = useRef(null); 

  // Handle input changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  // Handle image file selection
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setFormData({
      ...formData,
      image: file
    });
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const data = new FormData();
    data.append('title', formData.name);
    data.append('publish', formData.publish);
    if (formData.image) {
      data.append('image', formData.image);
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/brands/create`,
        data,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      // console.log('Brand create successfully', response.data);
      toast.success(`${response.data.message}`);
      setFormData({
        name: '',
        image: null,
        publish: false,
      });

      if (fileInputRef.current) {
        fileInputRef.current.value = ''; 
      }
    } catch (error) {
      // console.error('Error registering category', error.response?.data || error);
      toast.error(`Brand is not created`);
    }
  };

  return (
    <Box sx={{ maxWidth:{xs:"100%",md:'70%'}, margin:{xs:"0",md:'auto'}, padding:{xs:0,md:2}}}>
      <form onSubmit={handleSubmit}>
        <fieldset
          style={{
            border: '1px solid #ccc',
            padding: '18px',
            borderRadius: '8px',
            marginBottom: '20px'
          }}
        >
          <legend
            style={{
              padding: '8px',
              width: 'auto',
            //   marginBottom: '20px',
              background: '#3C7F10',
              color: '#fff',
              borderRadius: '8px',
            }}
          >
            Brands
          </legend>

          <Box sx={{ marginBottom: 2,maxWidth:{xs:"100%",sm:"100%",md:"100%"},width:{xs:"100%"}}}>
            {/* Label above the input */}
            <Typography variant="subtitle1" sx={{ marginBottom: 1,fontWeight:'500' }}>
            Title*
            </Typography>
            <TextField
            //   label="Category Name"
              variant="outlined"
              fullWidth
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            className='input-field-cls'   
            />
          </Box>
          <Box sx={{ marginBottom: 2 ,maxWidth:{xs:"250px",md:"100%"},width:{xs:"100%"}}}>
            {/* Label for the publish checkbox */}
            <FormGroup sx={{ marginBottom: 1, fontWeight:'500'}}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.publish}
                    onChange={handleChange}
                    name="publish"
                  />
                }
                label="Is Publish"
                
              />
            </FormGroup>
          </Box>

          <Box sx={{ marginBottom: 2 ,maxWidth:{xs:"250px",md:"100%"},width:{xs:"100%"}}}>
            {/* Label above the file input */}
            <Typography variant="subtitle1" sx={{ marginBottom: 1, fontWeight:'500'}}>
            Photo*
            </Typography>
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              style={{ marginBottom: '10px' }}
              ref={fileInputRef}
            />
            {/* {formData.image && <Typography variant="body2">{formData.image.name}</Typography>} */}
          </Box>  
        </fieldset>
        <Box sx={{ display: 'flex',justifyContent:'center', gap: 2 }}>
            <Button variant="contained" sx={{bgcolor:"green",color:'#fff'}} type="submit">
            <SaveIcon sx={{pr:1}}/>
              Save
            </Button>
            <Link to="/brands" style={{ textDecoration: 'none' }}>
              <Button variant="contained" sx={{bgcolor:"transparent",color:'green',boxShadow:'unset'}}>
              <SettingsBackupRestoreIcon sx={{pr:1}}/> 
                Back
              </Button>
            </Link>
          </Box>
      </form>
    </Box>
  );
};

export default CreateBrandForm;
